import classnames from 'classnames';
import { FC } from "react";
import type { MessageProps } from "./Message.types";

import styles from './Message.module.css';


const MessageBubble = () => {
    return (
        <div className={styles.bubble}>
            <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 12L18 0.774194L6.69767 0L0 12Z" fill="currentColor" />
            </svg>
        </div>
    )
}

export const Message: FC<MessageProps> = ({ children, owner }) => {
    return (
        <div className={
            classnames(
                styles.message,
                styles[`message-${owner}`]
            )
        }>
            <pre>{children}</pre>
            <MessageBubble />
        </div>
    )
};